import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { useEffect, useState } from "react";

import { getDataFromSessionStorage } from "./helper";

export const useSetUpDatadog = () => {
  const [uuid, setUuid] = useState();
  const [datadogSetUser, setDatadogSetUser] = useState();
  const [attemptFailed, setAttemptFailed] = useState(false);
  const [attempting, setAttempting] = useState(false);

  useEffect(() => {
    if (!datadogSetUser || attemptFailed || attempting || uuid) return;

    if (datadogSetUser === "COOKIE") {
      let attempts = 0;
      const maxAttempts = 10; // 10 sec

      const checkCookieAndSetUser = () => {
        const cookieValue = getDataFromSessionStorage("applicationTokens");
        if (cookieValue) {
          const { uuid } = cookieValue;

          if (!uuid) return;

          setUuid(uuid);
          clearInterval(intervalId);
        } else if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          console.warn("ApplicationTokens not found after multiple attempts.");
          setAttemptFailed(true);
        }
        attempts++;
      };

      const intervalId = setInterval(checkCookieAndSetUser, 1000);
      setAttempting(true);
      return () => {
        clearInterval(intervalId);
      };
    } else {
      setUuid(datadogSetUser);
    }
  }, [datadogSetUser, attemptFailed, attempting, uuid]);

  useEffect(() => {
    if (!uuid) return;
    datadogRum.setUserProperty({ id: uuid });
  }, [uuid]);

  return {
    setDatadogSetUser,
    attemptFailed,
    uuid,
  };
};

export const useLogger = (context = {}) => {
  const setUpDatadogProps = useSetUpDatadog();

  const createLog = ({ message, type, error, context }) => {
    if (type === "error") {
      datadogRum.addError(error || message, context);
    }

    datadogLogs.logger[type](message, context, error);
  };

  const { id } = datadogRum.getUser();

  const buildLogMessage = msg =>
    `env:${process.env.NEXT_PUBLIC_STAGE} message:${msg} ${
      id ? ` onmouuid:${id}` : ""
    }`;

  const error = (msg, error) =>
    createLog({
      message: buildLogMessage(msg),
      type: "error",
      context: {},
      error,
    });
  const log = msg =>
    createLog({ message: buildLogMessage(msg), type: "info", context });
  const warn = msg =>
    createLog({ message: buildLogMessage(msg), type: "warn", context });
  const debug = msg =>
    createLog({ message: buildLogMessage(msg), type: "debug", context });

  return {
    log,
    error,
    warn,
    debug,
    ...setUpDatadogProps,
    uuid: id,
  };
};
